<template>
    <form @submit.prevent="addPerson">
        <div class="input-wrapper">
            <input type="text" v-model="nameInput" placeholder="Add name" ref="nameInputField">
            <button class="round">+</button>
        </div>
    </form>
</template>

<style lang="scss"></style>

<script>
    import * as yup from 'yup';

    export default {
        name: 'AddPersonToList',

        data()
        {
            return {
                nameInput: ''
            };
        },

        mounted()
        {
            this.schema = yup.object().shape({
                // eslint-disable-next-line
                name: yup.string().required().trim().matches(/^[aA-zZ\s-]+$/, 'Special characters are not allowed.')
            });
        },

        methods: {
            addPerson()
            {
                this.schema.isValid({
                    name: this.nameInput
                }).catch( function( err )
                {
                    console.log( err.name, err.errors );
                }).then( ( valid ) =>
                {
                    if( valid )
                    {
                        this.$store.dispatch( 'people/addPerson', this.nameInput );
                    }
                });

                this.$refs.nameInputField.value = '';
            }
        }
    };
</script>
